module.exports = __webpack_public_path__ + "static/media/camera.df8bfeeb.png";